import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MakeApiCall } from "../apis";
import { useThemeMode } from "../contexts/ThemeContext";
import { setData } from "../redux/actions";
import { store } from "../redux/store";

const isValidTheme = (theme) => theme === "light" || theme === "dark";

export default function UserThemeSync() {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user?.data?.user?.user_data?.id);
  const serverTheme = useSelector((state) => state.user?.data?.user?.user_data?.theme);
  const token = useSelector((state) => state.user?.data?.token);
  const { setThemeMode } = useThemeMode();

  const lastSyncedUserIdRef = useRef(null);

  useEffect(() => {
    if (!userId) {
      lastSyncedUserIdRef.current = null;
      return;
    }

    if (lastSyncedUserIdRef.current === userId) {
      return;
    }

    lastSyncedUserIdRef.current = userId;

    if (isValidTheme(serverTheme)) {
      setThemeMode(serverTheme);
      return;
    }

    if (!token) {
      return;
    }

    let cancelled = false;

    (async () => {
      const response = await MakeApiCall(`user/${userId}`, "get", null, true, {}, token);
      if (cancelled || !response?.status) {
        return;
      }

      const theme = response?.data?.theme;
      if (!isValidTheme(theme)) {
        return;
      }

      const currentUserData = store.getState()?.user?.data;
      if (!currentUserData?.user?.user_data) {
        return;
      }

      dispatch(
        setData({
          ...currentUserData,
          user: {
            ...currentUserData.user,
            user_data: {
              ...currentUserData.user.user_data,
              theme,
            },
          },
        })
      );
      setThemeMode(theme);
    })();

    return () => {
      cancelled = true;
    };
  }, [userId, serverTheme, token, dispatch, setThemeMode]);

  return null;
}
